export default {
    ua_ua: 'UA',
    ua_avgd2: '平均次留',
    ua_spend: 'UA花费',
    ua_avgcpi: '平均每用户安装成本',
    ua_avgroas: 'UA平均投资回报率',
    ua_d2t1: '次留',
    ua_cpi: '用户安装成本',
    ua_ROAS: 'UA投资回报率',
    ua_engagementTrends: '活跃指标',
    ua_spendMetricsTrends: '花费指标趋势',
    ua_spend$: '花费指标趋势',
    ua_cpiTab: '单用户安装成本',
    ua_cpaTab: '单注册用户成本',
    ua_roasTab: 'UA投资回报率',
    // charts
    ua_no_spend_chart_Organic: '自然用户',
    ua_no_spend_chart_Others: '其他',
    ua_no_spend_chart_ua: 'UA',


    ua_Install: '安装',
    ua_Date: '日期',
    ua_Register: '注册',
    ua_Cohort_Register: '新安装注册用户率',
    ua_D2: '次留',
    ua_D3: '3留',
    ua_D7: '7留',
    ua_D14: '14留',
    ua_D30: '30留',
    ua_LTV1: '一天LTV',
    ua_LTV3: '三天LTV',
    ua_LTV7: '七天LTV',
    ua_LTV14: '14天LTV',
    ua_LTV30: '30天LTV',
    ua_LTV180: '180天LTV',
    ua_Overall_Performance: '指标总体表现',
    // table
    ua_table_Install: '安装',
    ua_table_Register: '注册',
    ua_table_spend: 'UA花费',
    ua_table_cpi: '每用户安装成本',
    ua_table_cpa: '每注册用户成本',
    ua_table_ROAS: 'UA投资回报率',
    ua_table_roasd1: '一天UA投资回报率',
    ua_table_roasd3: '三天UA投资回报率',
    ua_table_roasd7: '七天UA投资回报率',

    ua_Country_Region_Network_TypeBreakdown: '国家/区域/网络类型 排行榜',
    ua_tab_country: '国家',
    ua_tab_Region: '区域',
    ua_tab_Network: '网络类型',
    ua_Top_Country: '新进用户 Top 10 国家',
    ua_Top_Region: '新进用户 Top 10 区域',
    ua_Top_Network: '新进用户 Top 10 网络类型',
    ua_Top_Zone: '新进用户 Top 10 区服',

    ua_Ltv7_Top_Country: '七天LTV  Top 10 国家',
    ua_Ltv7_Top_Region: '七天LTV  Top 10 区域',
    ua_Ltv7_Top_Network: '七天LTV  Top 10  网络类型',

    ua_CPA_Top_Countries: '注册用户成本 Top 10 国家',
    ua_CPA_Top_Region: '注册用户成本 Top 10 区域',
    ua_CPA_Top_Network: '注册用户成本 Top 10 网络类型',

    ua_chart_register: '新进',
    ua_Sum_Register: '新进总数',
    ua_Register_chart: '新进',
    ua_Share_of_ALL: '全局占比',
    ua_Avg_LTV7: '平均七天LTV',
    ua_Avg_CPA: '平均七天注册用户成本',
    ua_Sum: '汇总值',

    ua_install: '安装',
    ua_register: '注册',
    ua_d2: '次留',
    ua_d3: '3留',
    ua_d7: '7留',
    ua_roas: 'UA投资回报率',
    ua_ltv_3: '三天LTV',
    ua_cpa: '单注册用户成本',

    ua_no_auth_message: '您目前无权限查看当前UA数据，请联系业务UA市场同学或vegarxu申请对应权限。'
};
/*
Install 安装
Register 注册
Cohort Register% 新安装注册用户率
Spend($)        UA花费
CPI($)        每用户安装成本
CPA($)         每注册用户成本
ROAS         UA投资回报率
 ROAS-D1        一天UA投资回报率
 ROAS-D3        三天UA投资回报率
 ROAS-D7        七天UA投资回报率

*/
